__turbopack_context__.v({
  "active": "Carousel-module-scss-module__bRseiG__active",
  "carousel": "Carousel-module-scss-module__bRseiG__carousel",
  "slide": "Carousel-module-scss-module__bRseiG__slide",
});
